module.exports = __webpack_public_path__ + "static/img/indicator_light04.fb937d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird/indicator_light04.png
// module id = BUA3
// module chunks = 1